export const EmptyArray: any[] = [];
export const EmptyMethod = () => {};
